import type { LocalStorageKey } from './types.ts';

export function serializeLocalStorageKey(args: LocalStorageKey) {
  if (args.version) {
    return `${args.key}-v${args.version}`;
  }
  return args.key;
}
